<template>
  <div>
    <div class="uk-flex uk-flex-column uk-margin uk-container" >

      <!-- uk-flex-center uk-flex-middle  -->
      <h1>{{page.title}}</h1>
      <div v-if="page.area_display > 0">
        <div v-if="page.content != '' " class="widget-content" v-html="page.content"></div>

        <google-map name="example" :area_id="page.area_display"></google-map>

      </div>
      <div v-else>
        <div class="widget-content" v-html="page.content"></div>
      </div>

    </div>


  </div>
</template>


<script>
//import { AUTH_LOGOUT } from "@/store/actions/auth.js";
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import axios from "axios";
import { settings } from "@/settings";

let API_SERVER = settings.API_SERVER;

export default {
  name: "Page",

  metaInfo() {
    return {
      title: this.page.title,
      meta: [
        { name: 'description', content: this.page.title,'vmid': 'og:image' },
        { name: 'og:image', content: this.page.featimage, 'vmid': 'og:image' },
      ]
    }
  },
  data: function () {
    return {
    page: {title: "title",featimage:"",content:"",permalink:""},
    debug: false
  }},
  methods: {
    logout: function() {
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push("/login"));
    },
    getPost() {
        var _vm = this;
        var clean_slug = this.$route.params.slug;
        if(clean_slug != ""){
          clean_slug = clean_slug.replace(".html","");
          if(clean_slug == "index"){
            console.log("page index.html route must go one level back");
            console.log(this.$route);
            clean_slug = this.$route.path.replace("/index.html","");
            clean_slug = clean_slug.replace("/","");
          }
        }

        axios
          .get(API_SERVER + '/_/items/pages?filter[key_code][eq]='+clean_slug)
          .then(response => {
            //console.log(response.data.data);
            if(response.data.data.length >0){
              this.page = response.data.data[0];
              //_vm.title = this.page.title;
              //_vm.$emit('updateHead');
            }
            else {
              this.page = {"title":"Pagina non trovata","content":"Si è verificato un errore"}
              //_vm.$emit('updateHead');
              console.log("page not found");
            }
        });
    }
  },
  created() {
      this.getPost()
  },
  mounted: function () {
    //console.log(this.$route.query.debug);
    if(this.$route.query.debug == "1234"){
      this.debug = true;
    }
    //console.log("mounted");
    //this.loadWebWidgets();
  },
};
</script>
